import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

import Icon from 'discada/dist/Icon'
import Chip, { ChipBody, ChipInfo } from './Chip'

import { getEntity } from 'selectors/entitySelectors'
import { goToVehiclePage } from 'actions/pageStateActions'

import './VehicleChip.scss'

export function VehicleChip(props) {
  let {
      vehicle = {},
      mini,
      children,
      side,
      className,
      flip = () => {},
      hasFlip,
      quoteId,
      goToVehiclePage,
      control,
      onClick,
    } = props,
    { year, model, make, trim } = vehicle,
    image = get(vehicle.images, '[0].url', null)

  onClick = onClick
    ? onClick
    : () => goToVehiclePage(vehicle.id, quoteId || vehicle.quoteId)

  return (
    <Chip
      {...props}
      className={c('vehicle-chip', className, { 'has-image': !!image })}
    >
      {!mini && (
        <ChipBody bg={image} onClick={onClick}>
          {children && (
            <div className="vehicle-chip-body-inner">{children}</div>
          )}
        </ChipBody>
      )}
      <ChipInfo>
        <div className="chip-info-main">
          <span className="year-make-model">
            {year} {model || make} {trim}{' '}
            <Icon size="small" icon="chevron-right" />
          </span>
        </div>

        <div className="chip-info-meta">
          {hasFlip && (
            <span
              onClick={flip}
              className={c('flip', { selected: side === 'back' })}
            >
              <Icon size="small" icon="sticky-note" />
              Flip
            </span>
          )}

          {control && <span className="chip-control">{control}</span>}
        </div>
      </ChipInfo>
    </Chip>
  )
}

function mapStateToProps(state, op) {
  let vehicle = getEntity(state, op.id) || {}

  return {
    ...op,
    image: get(vehicle, 'images[0].url', null),
    isLoading: isEmpty(vehicle),
  }
}

export default connect(
  mapStateToProps,
  { goToVehiclePage },
)(VehicleChip)
